import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AppConfig } from 'src/app/config/config';
import { ReplaySubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MicrosoftConfigService {
  private msalSettings: any = null;
  private http: HttpClient;
  private pathApi: string;
  private configReady$ = new ReplaySubject<boolean>(1);

  constructor(handler: HttpBackend, private config: AppConfig) {
    // We use HttpBackend to bypass interceptors (critical for bootstrap)
    this.http = new HttpClient(handler);
    this.pathApi = this.config.setting['pathApi'] + 'utility/';
  }

  async loadBackendConfig(): Promise<void> {
    // 1. Extract the ID from the URL (e.g., myapp.com?appId=123)
    const urlParams = new URLSearchParams(window.location.search);
    const idFromUrl = urlParams.get('client_id');
    const returnUrl = urlParams.get('redirect_uri');
    const returnDomain = this.extractDomainFromRedirectUrl(returnUrl);

    if (!idFromUrl) {
      console.error('No ID found in URL');
      this.configReady$.next(false);
      return;
    }

    try {
      const response: any = await firstValueFrom(
        this.http.get(`${this.pathApi}getEntraConfig/${idFromUrl}/${encodeURIComponent(returnDomain)}`)
      );

      this.msalSettings = response.data;
      this.configReady$.next(true);
    } catch (error) {
      console.error('Failed to load MSAL config from DB', error);
      this.configReady$.next(false);
    }
  }

  get clientId(): string {
    return this.msalSettings?.entraClientId;
  }

  get authority(): string {
    return this.msalSettings?.entraTenantId;
  }

  isConfigReady(): boolean {
    return !!this.clientId && !!this.authority;
  }

  onConfigReady(): Observable<boolean> {
    return this.configReady$.asObservable();
  }

  private extractDomainFromRedirectUrl(redirectUrl: string | null): string {
    if (!redirectUrl) {
      return '';
    }

    try {
      const decodedUrl = decodeURIComponent(redirectUrl);
      return new URL(decodedUrl).host;
    } catch {
      return '';
    }
  }
}